import { ReportManagementsArray } from './ReportManagementGetResponse';
import { ReportManagementPutRequest } from './ReportManagementPutRequest';

export interface ReportManagementModalView {
  id: number;
  date: string; // "YYYY-MM-DD"
  employeeCode: number;
  employeeName: string;
  projectId: number;
  projectNo: string;
  projectName: string;
  manHoursA: boolean;
  manHoursB: boolean;
  manHoursC: boolean;
  manHoursD: boolean;
  manHoursE: boolean;
  startTime: string; // "HH:mm"
  endTime: string; // "HH:mm"
  manHoursTotal: number; // 0.5刻み
}

export const toReportManagementModalView = (
  item: ReportManagementsArray | ReportManagementPutRequest
): ReportManagementModalView => {
  return {
    id: item.id,
    date: item.date,
    employeeCode: item.employeeCode,
    employeeName: item.employeeName,
    projectId: item.projectId,
    projectNo: item.projectNumber,
    projectName: item.projectName,
    manHoursA: item.manHoursCategory === 'A',
    manHoursB: item.manHoursCategory === 'B',
    manHoursC: item.manHoursCategory === 'C',
    manHoursD: item.manHoursCategory === 'D',
    manHoursE: item.manHoursCategory === 'E',
    startTime: item.startTime,
    endTime: item.endTime,
    manHoursTotal: item.manHoursTotal,
  };
};
